var ApplicationAPI = require('../../../common/api').Application;
var _ = require('underscore');

module.exports = function($scope) {

  var vm = this;

  function init() {
    var existingId = $scope.ngDialogData && $scope.ngDialogData.existingApplicationId;
    var funderId = $scope.ngDialogData && $scope.ngDialogData.funderId;
    var schemeId = $scope.ngDialogData && $scope.ngDialogData.schemeId;
    vm.schemes = [];
    vm.seekingPublicFunding = false;

    ApplicationAPI.GetApplicationsForDirectSubmission(funderId, schemeId).then(function(data) {
      vm.existingApplications = data;

      // only select the existing app if it's viable in the list
      if (existingId && _.find(data, function(d) { return d.id == existingId })) {
        vm.newApplication = false;
        vm.existingApplicationId = existingId;
      } else {
        vm.newApplication = true;
      }
    });
  }

  $scope.submit = function(form) {
    $scope.closeThisDialog({
      action: 'ok',
      newApplication: vm.newApplication,
      existingApplicationId: vm.existingApplicationId,
      projectTitle: form.projectTitle,
      seekingPublicFunding: form.seekingPublicFunding
    });
  };

  $scope.cancel = function() {
    $scope.closeThisDialog({ action: 'cancel' });
  };

  init();
}
